var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},".st0{fill:#222222;}"),React.createElement("g",{"key":1},React.createElement("path",{"d":"M12,23C5.93,23,1,18.07,1,12S5.93,1,12,1s11,4.93,11,11S18.07,23,12,23z M12,3c-4.96,0-9,4.04-9,9\r\n\t\tc0,4.96,4.04,9,9,9c4.96,0,9-4.04,9-9C21,7.04,16.96,3,12,3z"})),React.createElement("g",{"key":2},React.createElement("polygon",{"points":"18.9,13 11,13 11,5.59 13,5.59 13,11 18.9,11 \t"}))]);
}

Clock.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = Clock;

Clock.default = Clock;
